@if (loading) {
  <div class="spinner-overlay">
    <div class="spinner-container">
      <div class="spinner"></div>
      <span class="spinner-text">{{ text }}</span>
    </div>
  </div>
}
